/* Gas & Grain theme JS */
(function () {
  "use strict";

  /* ---------- takeover menu ---------- */
  function openMenu() {
    document.body.classList.add("menu-open");
    var b = document.querySelector(".menufab");
    if (b) b.setAttribute("aria-expanded", "true");
  }
  function closeMenu() {
    document.body.classList.remove("menu-open");
    var b = document.querySelector(".menufab");
    if (b) b.setAttribute("aria-expanded", "false");
  }
  window.ggToggleMenu = function () {
    document.body.classList.contains("menu-open") ? closeMenu() : openMenu();
  };

  /* ---------- cart drawer (AJAX) ---------- */
  var money = function (cents) { return "$" + (cents / 100).toFixed(2).replace(/\.00$/, ""); };

  function renderCart(cart) {
    var count = document.getElementById("cartCount");
    if (count) count.textContent = cart.item_count;
    var el = document.getElementById("cartLines");
    if (!el) return;
    if (cart.item_count === 0) {
      el.innerHTML = '<p style="color:var(--muted);font-size:11.5px">Nothing yet.</p>';
      return;
    }
    el.innerHTML = cart.items.map(function (it) {
      return '<div class="cline">' +
        '<div class="frame">' + (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, "_120x$1$2") + '" alt="">' : "") + "</div>" +
        '<div class="info">' + it.product_title +
        '<br><span style="color:var(--muted)">' + money(it.final_line_price) +
        (it.variant_title && it.variant_title !== "Default Title" ? " · " + it.variant_title : "") + "</span></div>" +
        '<button class="rm" data-key="' + it.key + '">remove</button></div>';
    }).join("");
    el.querySelectorAll(".rm").forEach(function (btn) {
      btn.addEventListener("click", function () {
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
        }).then(function (r) { return r.json(); }).then(renderCart);
      });
    });
  }
  function refreshCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart);
  }
  function openCart() { closeMenu(); document.body.classList.add("cart-open"); refreshCart(); }
  function closeCart() { document.body.classList.remove("cart-open"); }
  window.ggOpenCart = openCart;
  window.ggCloseCart = closeCart;

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeMenu(); closeCart(); }
  });

  /* intercept product forms -> AJAX add -> open drawer */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[data-gg-atc]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { if (btn) btn.disabled = false; openCart(); })
      .catch(function () { if (btn) btn.disabled = false; form.submit(); });
  });

  /* ---------- PDP media carousel ---------- */
  var car = document.querySelector("[data-gg-carousel]");
  if (car) {
    var slides = JSON.parse(car.getAttribute("data-media"));
    var idx = 0;
    var main = car.querySelector(".frame.main");
    var countEl = car.querySelector(".ccount");
    var thumbs = document.querySelectorAll("[data-gg-thumb]");
    function show(i) {
      idx = (i + slides.length) % slides.length;
      var m = slides[idx];
      main.innerHTML = m.t === "v"
        ? '<video src="' + m.u + '" autoplay muted loop playsinline></video>'
        : '<img src="' + m.u + '" alt="">';
      if (countEl) countEl.textContent = (idx + 1) + " / " + slides.length;
      thumbs.forEach(function (t, ti) { t.dataset.active = String(ti === idx); });
    }
    window.ggMedia = show;
    window.ggMediaStep = function (d) { show(idx + d); };
    var tx = null;
    car.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; }, { passive: true });
    car.addEventListener("touchend", function (e) {
      if (tx === null || slides.length < 2) return;
      var dx = e.changedTouches[0].clientX - tx; tx = null;
      if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* variant size picker (merch) */
  document.querySelectorAll(".sizes label").forEach(function (l) {
    l.addEventListener("click", function () {
      l.closest(".sizes").querySelectorAll("label").forEach(function (x) { x.classList.remove("on"); });
      l.classList.add("on");
    });
  });

  /* ---------- scroll reveal ---------- */
  var els = document.querySelectorAll(".rv");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  } else {
    els.forEach(function (e) { e.classList.add("in"); });
  }

  /* ---------- footer clock ---------- */
  function tick() {
    var n = new Date();
    var d = document.getElementById("fDate");
    var t = document.getElementById("fTime");
    if (d) d.textContent = n.toISOString().slice(0, 10).replace(/-/g, ".");
    if (t) t.textContent = n.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", second: "2-digit" });
  }
  setInterval(tick, 1000); tick();

  /* ---------- shop column toggle ---------- */
  window.ggCols = function (n) {
    document.body.classList.toggle("shop-1col", n === 1);
    try { localStorage.setItem("gg-cols", String(n)); } catch (e) {}
    document.querySelectorAll(".vt button").forEach(function (b, i) {
      b.setAttribute("aria-pressed", String((n === 1) === (i === 0)));
    });
  };
  try {
    if (localStorage.getItem("gg-cols") === "1") window.ggCols(1);
  } catch (e) {}

  /* mobile buy bar body padding */
  document.body.classList.toggle("has-mbuy", !!document.querySelector(".mbuy"));

  refreshCart();
})();

/* ---------- lightbox: tracked swipe / pinch-zoom / double-tap ---------- */
(function () {
  "use strict";
  var car = document.querySelector("[data-gg-carousel]");
  if (!car) return;
  var slides = JSON.parse(car.getAttribute("data-media"));
  if (!slides.length) return;

  var lb = null, track = null, count = null;
  var idx = 0, scale = 1, tx = 0, ty = 0;
  var ptrs = new Map(), startDist = 0, startScale = 1;
  var dragX = null, dragging = false, animating = false;
  var lastTap = 0, lastTapX = 0, lastTapY = 0;
  var W = function () { return window.innerWidth; };

  function mediaHTML(m, active) {
    return m.t === "v"
      ? '<video src="' + m.u + '" muted loop playsinline ' + (active ? "autoplay controls" : "preload=\"metadata\"") + '></video>'
      : '<img src="' + m.u + '" alt="">';
  }
  function cell(i, active) {
    var k = ((i % slides.length) + slides.length) % slides.length;
    return '<div class="lb-cell">' + mediaHTML(slides[k], active) + "</div>";
  }
  function curImg() {
    var c = track && track.children[1];
    var m = c && c.firstChild;
    return m && m.tagName === "IMG" ? m : null;
  }
  function applyZoom() {
    var img = curImg();
    if (img) img.style.transform = "translate(" + tx + "px," + ty + "px) scale(" + scale + ")";
  }
  function setTrack(x, animate) {
    track.style.transition = animate ? "transform .32s cubic-bezier(.22,1,.36,1)" : "none";
    track.style.transform = "translateX(" + x + "px)";
  }
  function renderTrack() {
    scale = 1; tx = 0; ty = 0;
    track.innerHTML = cell(idx - 1, false) + cell(idx, true) + cell(idx + 1, false);
    setTrack(-W(), false);
    if (count) count.textContent = (idx + 1) + " / " + slides.length;
  }
  function settle(dir) {
    if (animating) return;
    animating = true;
    var target = dir === 0 ? -W() : (dir > 0 ? -2 * W() : 0);
    setTrack(target, true);
    var done = false;
    var finish = function () {
      if (done) return; done = true;
      animating = false;
      if (dir !== 0) { idx = ((idx + dir) % slides.length + slides.length) % slides.length; }
      renderTrack();
    };
    track.addEventListener("transitionend", finish, { once: true });
    setTimeout(finish, 380);
  }
  function close() {
    if (lb) lb.classList.remove("on");
    document.body.classList.remove("lb-open");
    ptrs.clear(); dragging = false; dragX = null;
    if (track) track.innerHTML = "";
  }

  function build() {
    lb = document.createElement("div");
    lb.className = "lb";
    lb.innerHTML =
      '<div class="lb-track"></div>' +
      '<button class="lbx" aria-label="Close photos"><span class="bars"><i class="x1"></i><i class="x2"></i></span><span class="lbl">Close</span></button>' +
      (slides.length > 1
        ? '<button class="cnav prev" aria-label="Previous">&larr;</button><button class="cnav next" aria-label="Next">&rarr;</button><div class="lbcount count"></div>'
        : "");
    document.body.appendChild(lb);
    track = lb.querySelector(".lb-track");
    count = lb.querySelector(".lbcount");
    lb.querySelector(".lbx").addEventListener("click", close);
    var pv = lb.querySelector(".cnav.prev"), nx = lb.querySelector(".cnav.next");
    if (pv) pv.addEventListener("click", function () { settle(-1); });
    if (nx) nx.addEventListener("click", function () { settle(1); });
    document.addEventListener("keydown", function (e) {
      if (!lb.classList.contains("on")) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") settle(-1);
      if (e.key === "ArrowRight") settle(1);
    });

    lb.addEventListener("pointerdown", function (e) {
      if (e.target.closest(".lbx") || e.target.closest(".cnav") || animating) return;
      ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (ptrs.size === 1) {
        dragX = e.clientX;
        dragging = false;
      } else if (ptrs.size === 2) {
        var p = Array.from(ptrs.values());
        startDist = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        startScale = scale;
        if (dragging) { setTrack(-W(), false); dragging = false; }
        dragX = null;
      }
    });
    lb.addEventListener("pointermove", function (e) {
      if (!ptrs.has(e.pointerId) || animating) return;
      var prev = ptrs.get(e.pointerId);
      ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (ptrs.size === 2) {
        var p = Array.from(ptrs.values());
        var d = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
        if (startDist > 0) {
          scale = Math.min(4, Math.max(1, startScale * (d / startDist)));
          if (scale === 1) { tx = 0; ty = 0; }
          applyZoom();
        }
      } else if (ptrs.size === 1) {
        if (scale > 1) {
          tx += e.clientX - prev.x;
          ty += e.clientY - prev.y;
          var lim = (scale - 1) * Math.min(window.innerWidth, window.innerHeight) / 2 + 40;
          tx = Math.max(-lim, Math.min(lim, tx));
          ty = Math.max(-lim, Math.min(lim, ty));
          applyZoom();
        } else if (dragX !== null && slides.length > 1) {
          var dx = e.clientX - dragX;
          if (!dragging && Math.abs(dx) > 6) dragging = true;
          if (dragging) setTrack(-W() + dx, false);
        }
      }
    });
    lb.addEventListener("pointerup", function (e) {
      var wasSingle = ptrs.size === 1;
      ptrs.delete(e.pointerId);
      if (!wasSingle) return;
      var now = Date.now();
      var dx = dragX !== null ? e.clientX - dragX : 0;
      var isTap = Math.abs(dx) < 12 && !dragging;
      if (isTap && now - lastTap < 320 && Math.hypot(e.clientX - lastTapX, e.clientY - lastTapY) < 30) {
        if (scale > 1) { scale = 1; tx = 0; ty = 0; } else { scale = 2.5; }
        applyZoom();
        lastTap = 0; dragX = null; dragging = false;
        return;
      }
      if (isTap) { lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY; }
      if (dragging && scale === 1) {
        var th = Math.max(50, W() * 0.18);
        settle(Math.abs(dx) > th ? (dx < 0 ? 1 : -1) : 0);
      }
      dragX = null; dragging = false;
    });
    lb.addEventListener("pointercancel", function (e) {
      ptrs.delete(e.pointerId);
      if (dragging) { setTrack(-W(), true); dragging = false; }
      dragX = null;
    });
    window.addEventListener("resize", function () {
      if (lb.classList.contains("on") && !dragging && !animating) setTrack(-W(), false);
    });
  }

  window.ggLB = function () {
    if (!lb) build();
    var cc = document.querySelector("[data-gg-carousel] .ccount");
    idx = cc ? Math.max(0, parseInt(cc.textContent, 10) - 1 || 0) : 0;
    renderTrack();
    lb.classList.add("on");
    document.body.classList.add("lb-open");
  };
})();
